/* eslint-env browser */
import PropTypes from 'prop-types'
import * as React from 'react'
import analytics from '../../../../common/client/analytics'

import withTranslator from '../TranslatorProvider'

class PecheurComLink extends React.Component {
  constructor() {
    super()
    this.state = {}
  }

  render() {
    const { translate, product } = this.props

    let targetLink = ((product.supplierData || [])[0] || {}).pecheurPageUrl
    if (!targetLink) {
      return <div className="is-hidden" />
    }
    try {
      if (targetLink.match(/^(https:\/\/)?(www\.)?pecheur\.com(.*)/i)) {
        if (targetLink.includes('#1022137')) {
          targetLink = targetLink.replace('#1022137', '#af=1022137')
        } else if (!targetLink.includes('#af=1022137')) {
          targetLink = `${targetLink}#af=1022137`
        }
      }
    } catch (err) {}

    return (
      <div className="card has-margin-bottom-small has-margin-top-small">
        <div className="columns is-mobile is-multiline">
          <div className="column is-12 has-padding-bottom-zero">
            <a target="_blank" rel="noopener noreferrer" className="has-text-centered" href={targetLink}>
              <img
                className="image has-object-fit-contain is-self-centered"
                style={{ maxHeight: 60 }}
                src={
                  product.articles[0].medias[0]
                    ? product.articles[0].medias[0].url_300
                    : 'https://statics.fishfriender.com/statics/placeholder_tackle.png'
                }
                alt={product.seoName}
              />
              <img
                src="https://statics.fishfriender.com/statics/partners/logo_pecheur_square.png"
                target="_blank"
                alt="Pecheur.com"
                className="img-responsive"
                style={{
                  position: 'absolute',
                  top: 4,
                  right: 4,
                  maxHeight: 40,
                  maxWidth: '33%',
                }}
              />
            </a>
          </div>
          <div className="column is-12 has-padding-top-zero">
            <a
              target="_blank"
              rel="noopener noreferrer"
              className="has-text-centered"
              href={targetLink}
              onClick={analytics.trackEventSimple('clicked-pecheur-affiliate-from-sidebar')}
            >
              <div className="subtitle has-text-centered" style={{ fontSize: 13 }}>
                {product.supplierData[0].pecheurFullName}
              </div>
              {product.articles.length > 0 &&
                (product.articles[0].supplierData || []).length > 0 &&
                product.articles[0].supplierData[0].pecheurPricesEuro &&
                product.articles[0].supplierData[0].pecheurPricesEuro.FR && (
                  <div className="title has-text-weight-bold" style={{ color: '#4a4a4a', fontSize: 17 }}>
                    {translate('ads.product.price', {
                      price: product.articles[0].supplierData[0].pecheurPricesEuro.FR || '',
                    })}
                  </div>
                )}
              <div className="subtitle  has-text-weight-bold has-text-info" style={{ color: '#4a4a4a', fontSize: 13 }}>
                {translate('ads.product.buyOnPecheur')}
              </div>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

PecheurComLink.propTypes = {
  product: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

PecheurComLink.defaultProps = {}

module.exports = withTranslator(PecheurComLink)
